import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isNotDarkTheme } from '../../theme/style-mixins/isDarkTheme/isNotDarkTheme-BpLwrzY3.js';
import { g as globalStyles, p as primaryAiStyles, d as defaultAiStyles, s as smallStyles, n as normalStyles, l as loadingStyles } from '../Button.styles-Ck-xVxAl.js';
import { a as TaktIdConsumer } from '../../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { I as Icon } from '../../Icon/Icon-CoM8rI0H.js';
import { s as spinner, d as sparkleSolid } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';

const StyledIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1u22imc-0"
})([""]);
const StyledButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-40026394__sc-1u22imc-1"
})(["", ";", ";", ";", " &&:focus-visible{", "}", " margin:0;"], globalStyles, ({
  $variant
}) => {
  if ($variant === 'primary') {
    return primaryAiStyles;
  }
  return defaultAiStyles;
}, ({
  $size
}) => $size === 'small' ? smallStyles : normalStyles, ({
  $loading
}) => $loading && css(["", " border-color:transparent;"], loadingStyles), focusOutline, ({
  $variant
}) => $variant !== 'primary' && isNotDarkTheme(css(["&&:hover:not(:disabled) ", "{color:", ";}"], StyledIcon, ({
  theme
}) => theme.support.iconColor.ai)));
const AIButton = ({
  type = 'button',
  variant = 'default',
  buttonRef,
  children,
  disabled,
  loading,
  loadingLabel,
  onClick,
  size = 'base',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('ai-button')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, getDataTaktAttributes(), rest, {
  $variant: variant,
  disabled: disabled,
  type: type,
  ref: buttonRef,
  $size: size,
  $loading: loading
}, loading && {
  'aria-live': 'assertive'
}, (loading || disabled) && {
  'aria-disabled': true
}, {
  onClick: loading ? undefined : onClick
}), loading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Icon, {
  type: spinner,
  size: size
}), loadingLabel || children), !loading && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledIcon, {
  type: sparkleSolid,
  size: size
}), children)));

export { AIButton as A };
//# sourceMappingURL=AIButton-CBWEpu2T.js.map
